import { Minute } from '@nu-art/ts-common';
export const DefaultTTL_FocusedObject = 10 * Minute;
export const getRelationalPath = () => `/state/ModuleBE_FocusedObject/focusedData/`;
//# sourceMappingURL=consts.js.map